/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import { ONLINE_STATUS_UPDATE } from './actionTypes';
import { combineReducers } from 'redux';

export function isOnline(state = true, action) {
  const { type, payload } = action;

  switch (type) {
    case ONLINE_STATUS_UPDATE:
      return payload.isOnline;
    default:
      return state;
  }
}

export default combineReducers({
  isOnline,
});
